/**
 * This enum contains the metric type ids for operational metrics.
 * Currently, this only contains values that are needed a for specific reason in
 * the UI.
 */
export enum OperationalMetricTypeIds {
    EMPLOYEE_COUNT = "778f871d-72ba-4c84-879d-66cfc3cbd76d"
}